
const AVAILABILITY_STATUS_TEXT_MAPPING = {
    available: 'available',
    tempNotAvailable: 'temporary-unavailable',
    soldOut: 'unavailable'
};

const AVAILABILITY_TEST_STATUS_TEXT_MAPPING = {
    ...AVAILABILITY_STATUS_TEXT_MAPPING,
    notifiable: 'notifiable'
}


function mapToAvailabilityStatus(productContentAvailability) {
    return mapToStatusText(productContentAvailability, AVAILABILITY_STATUS_TEXT_MAPPING, "");
}

function mapToTestAvailabilityStatus(productContentAvailability) {
    return mapToStatusText(productContentAvailability, AVAILABILITY_TEST_STATUS_TEXT_MAPPING, " ");
}

function mapToStatusText(availability, statusTexts, statusDivider) {
    if(!availability || !statusTexts) {
        return "";
    }

    //checks if the given statusTexts contains a text for every specified property of
    //the given availability object and combines a statusText string of all properties
    //which are set to true. All texts are divided by the statusDivider value.
    return Object.keys(availability)
        .filter(availabilityAttribute => !!statusTexts[availabilityAttribute])
        .filter(availabilityAttribute => availability[availabilityAttribute])
        .map(availabilityAttribute => statusTexts[availabilityAttribute])
        .reduce((allStatus, statusTextValue) => allStatus + statusTextValue + statusDivider, "")
        .trim();
}



export default {
    mapToAvailabilityStatus,
    mapToTestAvailabilityStatus
}